var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "header__greetings--agent" }, [
    _c("div", { staticClass: "header__top" }, [
      _c("button", {
        staticClass: "action-icon close",
        attrs: { "aria-label": _vm.$gettext("Cerrar chat"), tabindex: "0" },
        on: {
          click: _vm.closeChat,
          keyup: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.closeChat.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "space", 32, $event.key, [
                  " ",
                  "Spacebar",
                ])
              )
                return null
              return _vm.closeChat.apply(null, arguments)
            },
          ],
        },
      }),
      _c("div", { staticClass: "header__agent" }, [
        (_vm.config && _vm.config.logo && _vm.logoExists) ||
        (_vm.agent.avatar && _vm.avatarExists)
          ? _c("div", { staticClass: "agent__avatar" }, [
              _vm.config && _vm.config.logo
                ? _c("img", {
                    staticClass: "header-logo",
                    attrs: {
                      src: _vm.getFullLogoUrl(_vm.config.logo),
                      alt: "Logotipo",
                    },
                  })
                : _c("img", {
                    attrs: { src: _vm.agent.avatar, alt: _vm.agent.name },
                  }),
            ])
          : _c("div", { staticClass: "agent__avatar default" }),
        _c("div", { staticClass: "agent__data" }, [
          _vm.config && _vm.config.primary_greeting
            ? _c(
                "p",
                {
                  staticClass: "bold__greeting",
                  attrs: {
                    title: _vm.$gettext("Tema del chat"),
                    tabindex: "0",
                  },
                },
                [_vm._v(_vm._s(_vm.config.primary_greeting))]
              )
            : _c(
                "p",
                {
                  staticClass: "bold__greeting",
                  attrs: {
                    title: _vm.$gettext("Nombre del agente"),
                    tabindex: "0",
                  },
                },
                [_vm._v(_vm._s(_vm.agent.name))]
              ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "header-back" }, [
      _vm.isVideoCallAvailable && !this.isBanned && this.isVideoChatAvailable
        ? _c("button", {
            ref: "callIcon",
            staticClass: "action-icon call",
            attrs: {
              tabindex: "0",
              "aria-label": _vm.$gettext("Iniciar videoasistencia."),
              title: _vm.$gettext("Iniciar videollamada con tu agente"),
            },
            on: {
              mouseenter: _vm.handleMouseEnter,
              mouseleave: _vm.handleMouseLeave,
              click: _vm.CallFormTrue,
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.CallFormTrue.apply(null, arguments)
              },
            },
          })
        : this.call && this.threadState != "closed"
        ? _c(
            "div",
            {
              staticClass: "action-icon call disabled",
              attrs: {
                tabindex: "0",
                title: _vm.$gettext("Videollamada no disponible"),
                "aria-label": _vm.$gettext("Videollamada deshabilitada."),
              },
            },
            [_c("div", { staticClass: "call-active" })]
          )
        : _vm._e(),
      _vm.showTooltip
        ? _c(
            "div",
            { ref: "tooltip", staticClass: "tooltip", style: _vm.tooltipStyle },
            [
              _vm._v(
                _vm._s(
                  _vm.$gettext(
                    "Iniciar videollamada con tu agente. Solo el agente compartirá imagen y pantalla."
                  )
                )
              ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }